import { RECEIVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IPrivateCompany, type IPrivateCompanyLink } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { PRIVATE_COMPANY_MODULE } from '../private-company-module';

type IPrivateCompanyLinkDTO = Omit<IPrivateCompanyLink, 'toCompany' | 'fromCompany'> & { toCompany: number; fromCompany: number };

export const actions: ActionTree<IPrivateCompanyLink, unknown> = {
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: Array<IPrivateCompanyLink | IPrivateCompanyLinkDTO> }) {
        const companyIds = new Set<number>();
        const companies: IPrivateCompany[] = [];

        dataObjectList.forEach((linkedCompany) => {
            if (typeof linkedCompany.fromCompany === 'object') {
                const fromCompany = linkedCompany.fromCompany;

                if (!companyIds.has(fromCompany.dobjId)) {
                    companies.push(fromCompany);
                    companyIds.add(fromCompany.dobjId);
                }

                linkedCompany.fromCompany = fromCompany.dobjId;
            }

            if (typeof linkedCompany.toCompany === 'object') {
                const toCompany = linkedCompany.toCompany;

                if (!companyIds.has(toCompany.dobjId)) {
                    companies.push(toCompany);
                    companyIds.add(toCompany.dobjId);
                }

                linkedCompany.toCompany = toCompany.dobjId;
            }
        });

        context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList });

        if (companies.length > 0) {
            void context.dispatch(`${PRIVATE_COMPANY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: companies }, { root: true });
        }
    }
};
